import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Unlucky.scss";
import arrow from "../../../assets/arrow.png";
import Footer from "../../../components/Footer/Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import { useState } from "react";




// -------------------------------------------------------
// UNLUCKY NUMBER PROFILES (KEPT INSIDE THIS SAME FILE)
// -------------------------------------------------------
export const unluckyProfiles = {
  1: {
    title: "Unlucky 1 – Isolation & Ego Struggles",
    keywords: "Loneliness · Pressure · Self-focus",
    overview:
      "When 1 operates as an unlucky influence, it can turn strong individuality into isolation or ego conflict.",
    challenges: [
      "Feeling misunderstood or unsupported",
      "Becoming overly stubborn or controlling",
      "Difficulty asking for help",
    ],
    influence:
      "Unlucky 1 can show phases where independence becomes a burden, leading to emotional exhaustion.",
    guidance:
      "Collaborate more and avoid taking everything on alone. Humility and teamwork reduce the negative impact of 1.",
  },

  2: {
    title: "Unlucky 2 – Over-Sensitivity & Doubt",
    keywords: "Emotional imbalance · Insecurity · Dependency",
    overview:
      "The unlucky side of 2 increases emotional sensitivity, hesitation, and dependence.",
    challenges: [
      "Fear of conflict",
      "Difficulty making decisions alone",
      "Emotional overwhelm",
    ],
    influence:
      "May experience emotional fluctuations or relationship misunderstandings.",
    guidance:
      "Strengthen emotional boundaries and communicate clearly. Build inner confidence.",
  },

  3: {
    title: "Unlucky 3 – Scattered Energy",
    keywords: "Distraction · Inconsistency · Surface-level thinking",
    overview:
      "Creativity becomes chaos when 3 turns unlucky. Projects remain unfinished.",
    challenges: ["Inconsistent focus", "Procrastination", "Talking more than doing"],
    influence:
      "Periods of distraction or lack of discipline may limit progress.",
    guidance:
      "Focus on fewer goals and create simple daily structure.",
  },

  4: {
    title: "Unlucky 4 – Blockages & Delays",
    keywords: "Restrictions · Rigidity · Slow Progress",
    overview:
      "When 4 is unlucky, life feels heavy and restricted. Obstacles appear frequently.",
    challenges: ["Feeling stuck", "Overthinking", "Resisting change"],
    influence:
      "A cycle of delays or rigid responsibilities may appear.",
    guidance:
      "Stay flexible. Try new methods. Small adjustments weaken the negative 4 energy.",
  },

  5: {
    title: "Unlucky 5 – Instability & Impulsiveness",
    keywords: "Chaos · Risk · Restlessness",
    overview:
      "The unlucky vibration of 5 manifests as sudden changes, instability, or impulsive decisions.",
    challenges: ["Lack of commitment", "Risk-taking", "Overindulgence"],
    influence:
      "Can indicate unstable periods, frequent changes, or scattered energy.",
    guidance:
      "Add structure to freedom. Avoid emotional decision-making.",
  },

  6: {
    title: "Unlucky 6 – Over-responsibility",
    keywords: "Burden · Anxiety · Control",
    overview:
      "Unlucky 6 can make you take on too much responsibility and emotional load.",
    challenges: ["Carrying others' problems", "Worry", "Feeling unappreciated"],
    influence:
      "Family stress or emotional overwork is common.",
    guidance:
      "Set healthy boundaries and don't overcommit.",
  },

  7: {
    title: "Unlucky 7 – Isolation & Overthinking",
    keywords: "Doubt · Withdrawal · Confusion",
    overview:
      "The shadow side of 7 causes excessive thinking and emotional distance.",
    challenges: ["Loneliness", "Analysis paralysis", "Difficulty expressing feelings"],
    influence:
      "Periods of confusion or emotional detachment may arise.",
    guidance:
      "Share thoughts with trusted people and avoid staying isolated.",
  },

  8: {
    title: "Unlucky 8 – Financial Pressure & Karma",
    keywords: "Losses · Power Struggles · Stress",
    overview:
      "Unlucky 8 can cause financial instability or conflicts about control.",
    challenges: [
      "Money issues",
      "Conflict with authority",
      "Work pressure",
    ],
    influence:
      "Karmic lessons around fairness and responsibility may appear.",
    guidance:
      "Stay ethical and plan long-term. Avoid power struggles.",
  },

  9: {
    title: "Unlucky 9 – Endings & Emotional Burden",
    keywords: "Closure · Letting Go · Intensity",
    overview:
      "Unlucky 9 increases emotional heaviness and difficulty releasing the past.",
    challenges: [
      "Emotional overload",
      "Holding onto old pain",
      "Sacrificing too much",
    ],
    influence:
      "Can bring endings or emotional tests before growth.",
    guidance:
      "Practice self-care and release past attachments.",
  },

  11: {
    title: "Unlucky 11 – Over-Sensitivity",
    keywords: "Anxiety · Intuition Overload · Imbalance",
    overview:
      "Master Number 11 becomes unlucky when intuition becomes overwhelming.",
    challenges: ["Anxiety", "Sleep issues", "Emotional tension"],
    influence:
      "Spiritually intense but confusing phases may occur.",
    guidance:
      "Ground yourself. Focus on routine and simple daily tasks.",
  },

  22: {
    title: "Unlucky 22 – Pressure of Big Goals",
    keywords: "Overload · Failed Plans · Unrealistic Expectations",
    overview:
      "22 becomes unlucky when responsibilities become overwhelming.",
    challenges: ["Taking on too much", "Fear of failure", "Frustration"],
    influence:
      "Large goals may face delays or restructuring.",
    guidance:
      "Break large projects into smaller steps and ask for help.",
  },

  33: {
    title: "Unlucky 33 – Over-Sacrifice",
    keywords: "Burnout · Emotional Exhaustion · Idealism",
    overview:
      "Unlucky 33 causes emotional overload and unrealistic expectations.",
    challenges: ["Overgiving", "Burnout", "Disappointment"],
    influence:
      "Frequently involves emotional intensity in relationships.",
    guidance:
      "Help others, but protect your own energy. Set boundaries.",
  },
};


// --- Profiles remain unchanged ---
// import { unluckyProfiles } from "./unluckyProfiles"; // If separate file, else keep your object

const Unlucky = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    year: "2000",
    month: "May",
    day: "26",
    gender: "male" // ✅ DEFAULT, NO UI
  });

  const [resultData, setResultData] = useState(null);
  const [showReport, setShowReport] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, year, month, day } = formData;
    const birthDay = Number(day);
    const birthMonth = new Date(`${month} 1, 2000`).getMonth() + 1;
    const birthYear = Number(year);

    try {
      setLoading(true);

      const { gender } = formData;

      const res = await axios.get(
        `https://core-c343.onrender.com/api/lucky-number` +
        `?firstName=${firstName}` +
        `&lastName=${lastName}` +
        `&birthYear=${birthYear}` +
        `&birthMonth=${birthMonth}` +
        `&birthDay=${birthDay}` +
        `&gender=${gender}`
      );

      setResultData(res.data);
      setShowReport(true);
    } catch (error) {
      console.error("API error:", error);
      setResultData({
        error: "Unable to compute unlucky number. Please try again.",
      });
      setShowReport(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTryAgain = () => {
    setShowReport(false);
    setResultData(null);
  };

  // 🔥 UPDATED: Read unlucky number correctly from API
  // const unluckyNum = resultData?.data?.numerology?.numbers?.[0];
  const unluckyNum = resultData?.data?.numerology?.unluckyNumber;

  // 🔥 Profile for this unlucky number
  const profile = unluckyProfiles[unluckyNum];

  return (
    <div className="unlucky-container">
      <InnerNav />

      <div className="unlucky-content">
        <Zodiac />

        <div className="left-unlucky">
          {/* ---------------- FORM VIEW ---------------- */}
          {!showReport && (
            <>
              <div className="header">
                <h1>Unlucky Number Calculator</h1>
                <p>
                  Discover which number brings challenges into your numerology
                  chart and how to correct its effects.
                </p>
              </div>

              <div className="card1">
                <h3>Enter Your Details</h3>

                <form className="card-content" onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="text"
                    name="middleName"
                    placeholder="Middle Name (Optional)"
                    value={formData.middleName}
                    onChange={handleChange}
                  />

                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />

                  <select name="year" value={formData.year} onChange={handleChange}>
                    {Array.from({ length: 110 }).map((_, i) => {
                      const y = 2025 - i;
                      return (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      );
                    })}
                  </select>

                  <select name="month" value={formData.month} onChange={handleChange}>
                    {[
                      "January","February","March","April","May","June",
                      "July","August","September","October","November","December",
                    ].map((m) => (
                      <option key={m}>{m}</option>
                    ))}
                  </select>

                  <select name="day" value={formData.day} onChange={handleChange}>
                    {[...Array(31)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                                    <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>

                  <button type="submit" disabled={loading}>
                    {loading ? "Generating Report..." : "Show My Unlucky Number"}
                  </button>
                </form>
              </div>
            </>
          )}

          {/* ---------------- REPORT VIEW ---------------- */}
          {showReport && (
            <div className="report-card">
              <h1>Your Unlucky Number Report</h1>

              {resultData?.error ? (
                <p className="error-text">{resultData.error}</p>
              ) : (
                <>
                  {/* MAIN NUMBER DISPLAY */}
                  <div className="hero-number-box">
                    <div className="number-circle">{unluckyNum}</div>
                    <h2>{profile?.title}</h2>
                    <p className="keywords">{profile?.keywords}</p>
                  </div>

                  {/* USER DETAILS */}
                  <div className="report-section">
                    <h3>Your Details</h3>
                    <p>
                      <strong>Name:</strong> {formData.firstName}{" "}
                      {formData.middleName} {formData.lastName}
                    </p>
                    <p>
                      <strong>Date of Birth:</strong> {formData.day} {formData.month}{" "}
                      {formData.year}
                    </p>
                  </div>

                  {/* NEW — Showing API extra info */}
                  <div className="report-section">
                    <h3>Why This Number Is Unlucky</h3>
                    <p>{resultData?.data?.numerology?.reason}</p>

                    {/* <ul>
                      <li>
                        <strong>Life Path:</strong>{" "}
                        {resultData?.data?.numerology?.details?.lifePath}
                      </li>
                      <li>
                        <strong>Expression Number:</strong>{" "}
                        {resultData?.data?.numerology?.details?.expression}
                      </li>
                    </ul> */}

                  </div>

                  {/* PROFILE CONTENT */}
                  <div className="report-section">
                    <h3>Overview</h3>
                    <p>{profile?.overview}</p>
                  </div>

                  <div className="report-section">
                    <h3>Influence in Your Life</h3>
                    <p>{profile?.influence}</p>
                  </div>

                  <div className="report-section">
                    <h3>Key Challenges</h3>
                    <ul>
                      {profile?.challenges?.map((c, i) => (
                        <li key={i}>{c}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="report-section">
                    <h3>Guidance</h3>
                    <p>{profile?.guidance}</p>
                  </div>
                </>
              )}

              <button className="try-again-btn" onClick={handleTryAgain}>
                Try Again
              </button>
            </div>
          )}
        </div>

        {/* RIGHT SIDEBAR */}
        <div className="right-numerology">
          <h4>Popular in Numerology</h4>
          <div className="right-links">
                       <Link to="/numerology/luckynum"><p><img src={arrow}/> Lucky Number</p></Link>
            <Link to="/numerology/chinese-lucky"><p><img src={arrow}/> Chinese Lucky</p></Link>
            <Link to="/numerology/unlucky"><p><img src={arrow}/> Unlucky Number</p></Link>
            <Link to="/numerology/life-path"><p><img src={arrow}/> Life Path</p></Link>
            <Link to="/numerology/destiny"><p><img src={arrow}/> Destiny Number</p></Link>
            <Link to="/numerology/birth"><p><img src={arrow}/> Birth or Root Number</p></Link>
            <Link to="/numerology/soul"><p><img src={arrow}/> Soul Urge Number</p></Link>
            <Link to="/numerology/name"><p><img src={arrow}/> Name Number</p></Link>
            <Link to="/numerology/balance"><p><img src={arrow}/> Balance Number</p></Link>
            <Link to="/numerology/lo-shu-grid"><p><img src={arrow}/> Lo Shu Grid Analysis</p></Link>
            <Link to="/numerology/kua"><p><img src={arrow}/> Kua Number</p></Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Unlucky;
